import type { FC } from "react";
import { useState } from "react";
import type { ReactFormExtendedApi } from "@tanstack/react-form";

import UpdateTabForm from "@/components/form/patient/update-tab-form";
import TabSelector from "@/components/layout/tab-selector";
import type { UpdatePatientFormData } from "@/schemas/patient";
import type { UpdateTab } from "@/types/utils";
import { updateTabChoices } from "@/types/utils";

export type UpdateFieldProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formApi: ReactFormExtendedApi<
    UpdatePatientFormData,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any
  >;
};

const UpdateForm: FC<UpdateFieldProps> = ({ formApi }) => {
  const [selectedTab, setSelectedTab] = useState("INFOS");

  return (
    <div className="flex flex-col lg:flex-row gap-6 lg:gap-24">
      <div className="lg:min-w-fit">
        <TabSelector
          choices={updateTabChoices}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
      </div>
      <div className="flex-1 min-w-0">
        <UpdateTabForm
          selectedTab={selectedTab as UpdateTab}
          formApi={formApi}
        />
      </div>
    </div>
  );
};

export default UpdateForm;
